<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <tbody>
                        <tr v-for="(company, index) in companies" v-if="!loading" :key="index">
                            <td>
                                {{ company.designation }} 
                                <input type="hidden" :name="'companies[' + index + '][id]'" v-model="company.id">
                                <input type="hidden" :name="'companies[' + index + '][designation]'" v-model="company.designation">
                                <div v-if="fillDetails" class="mt-2"> 
                                    <input type="text" class="form-control form-control-sm" :name="'companies[' + index + '][role]'" v-model="company.role" placeholder="Indiquer le rôle occupé par cette société si celui-ci est connu">
                                </div>
                            </td>
                            <td class="text-right">
                                <button type="button" class="btn btn-sm transparent" @click="deleteRow(index)">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="2" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-show="!loading">
                            <td colspan="2">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="companySearchInput" type="text" v-model="company">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: 'company-selector',
        props: ['route', 'oldCompanies', 'exclude', 'fillDetails', 'canCreate'],
        data() {
            return {
                loading: true,
                company: null,
                companies: []
            };
        },
        methods : {
            addRow: function (company) {    
                if (company && company.id && this.getCurrentSelectedCompaniesId().includes(company.id) == false && (this.exclude == undefined || (this.exclude != undefined && this.exclude != company.id))) {
                     this.companies.push({
                            id: company.id,
                            designation: company.designation,
                            role : this.fillDetails && company.role ? company.role : null
                        });
                }   else {
                    if(this.company != ''){
                        this.companies.push({
                            id: null,
                            designation: company && company.designation ? company.designation : company,
                            role : null
                        })
                    }
                   
                }
            },
            deleteRow: function (index) {
                this.companies.splice(index, 1)
            },
            getCurrentSelectedCompaniesId: function() {
                return this.companies.map(company => company.id);
            },

        },
        mounted(){
            $("#companySearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.route,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedCompaniesId().join(';') + (this.exclude != undefined ? (';' + this.exclude) : '') },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                       
                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.designation}</span>
                                    </div>`;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){          
                        if(this.canCreate)              
                            this.addRow(this.company);
                        $(e.target).val("");
                        this.company = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRow(item.item)
                        $(e.target).val("")
                        this.company = null
                    }
                },
            }).focus(() => {
                $("#companySearchInput").autocomplete("search", '');
            });

            const jsonCompanyBackup = JSON.parse(this.oldCompanies)
            if (Array.isArray(jsonCompanyBackup)) {
                if (jsonCompanyBackup.length > 0) {
                    jsonCompanyBackup.forEach(company => {
                        this.addRow(company)
                    })
                }
            }
            this.loading = false
        }
    }
</script>
